// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"heroscrim_wrapper__lXagq","bgImage":"heroscrim_bgImage___j2DV"};